import React from 'react'
import { styled } from '@mui/system'
import { CardHeader, Grid, Typography } from '@mui/material'
import { FEINTextField, DateField, SSNTextField, TextField } from '../../../../../ui'
import { generateUtilityClasses } from '@mui/material'
import { useFormState } from 'react-final-form'
import { useSelector } from 'react-redux'
import { getStates } from '../../../../../redux/slices/userDropdownSlice'
import DropdownFieldSearch from '../../../../../ui/DropdownFieldSearch'

const classes = generateUtilityClasses('Grid', ['root', 'row', 'optionalText'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.optionalText}`]: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 400,
    Size: '0.8750em',
    fontStyle: 'italic',
    lineHeight: '1.1875em',
    marginLeft: theme.spacing(1),
  },
}))

interface Props {}

export const IdentityForm = ({}: Props) => {
  const { values } = useFormState()
  const states = useSelector(getStates)

  return (
    <>
      <CardHeader title='Identity (optional)' />
      <Grid container spacing={2} padding={3}>
        {values?.ApplicantAccountType === 'individual' ? (
          <>
            <Grid item xs={6}>
              <DateField name='ApplicantDateOfBirth' label='Date Of Birth' disableFuture fullWidth />
            </Grid>
            <Grid item xs={6}>
              <SSNTextField name='ApplicantTaxIDNumber' label='SSN' fullWidth />
            </Grid>
          </>
        ) : (
          <Grid item xs={6}>
            <FEINTextField name='ApplicantTaxIDNumber' label='FEIN' fullWidth />
          </Grid>
        )}
        <Grid item xs={4}>
          {/* TODO No Backend value*/}
          <TextField name='ApplicantLicenseNumber' label='License Number' fullWidth autoComplete='off' /> {/*dlState*/}
        </Grid>
        <Grid item xs={2}>
          <DropdownFieldSearch // {/*dlState*/}
            name='ApplicantLicenseState'
            label='State'
            options={states}
            optionKey='State'
            optionValue='State'
            autoComplete='off'
          />
        </Grid>
        <Grid item xs={3}>
          <DateField name='ApplicantLicenseIssued' label='License Issued' disableFuture fullWidth />
        </Grid>
        <Grid item xs={3}>
          <DateField name='ApplicantLicenseExpiration' label='License Expiration' fullWidth />
        </Grid>
      </Grid>
    </>
  )
}

export default IdentityForm
